////////////////////////////////////////////////////////////////////////////////
// LASTMOD:
// 20200728, SB: minified, bg-color, alignment
import React from "react";
import axios from "axios";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import BarLoader from 'react-spinners/BarLoader';   // spinner for loading
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/AccountSetup.css';
import './formComponents.js';
//import { Link } from 'react-router-dom';
import Analytics from 'analytics';
import snowplowPlugin from '@analytics/snowplow';
import { TextInput, AlertUser } from './formComponents.js';
import { config } from './config.js';

// 20200922, SB: Test Snowplow NPM! 
const analytics = Analytics({
  app: "rule-app-npm",
  plugins: [
    // Minimal recommended configuration
    snowplowPlugin({
      name: "snowplow",
      scriptSrc: "https://www.ruhrnachrichten.de/Media/schneepflug/schneepflug.js",
      collectorUrl: "collector.rn.de",
      trackerSettings: {
        appId: "rule_widget_npm",
        encodeBase64: false, // SB: HAS TO BE FALSE
        discoverRootDomain: true,
        cookieName: "schneepflug.rn.de", //  might be changed
        respectDoNotTrack: true,
        userFingerprint: true,
        userFingerprintSeed: 6385924667,
        forceSecureTracker: true,
        post: false,
        bufferSize: 1, // SB: NO! no buffers! > allways send!
        maxPostBytes: 50000, // SB: max 50k (kinetics limit)
        stateStorageStrategy: "cookieAndLocalStorage",
        contexts: {
          webPage: true,
          performanceTiming: true,
        },
      },
    }),
  ],
});

analytics.page();



// TODO: empty für "settings" view
let validation = Yup.object({
  email: Yup.string().email("E-Mail-Adresse ungültig").required("Bitte geben Sie eine gültige E-Mail-Adresse an."),
  //acceptedTerms: Yup.boolean().required("Pflicht").oneOf([true], "Bitte akzeptieren Sie die Datenschutzbestimmungen!"),
})


////////////////////////////////////////////////////////////////////////////////
// signup form  
class SignupForm extends React.Component {
  // Constructor: inits state for form values and corresponding JSON
  constructor(props) {
    super(props);

    // parameter queries
    const query = new URLSearchParams(window.self.location.search);
    const account = query.get("account");
    const account_id = config.accounts[account];
    const mail_key = query.get("nl");
    
    // get portal setup from config; by account_id
    this.state = {
      portal: { ...config.portals[account_id] },
      mail_key: mail_key,
      message: '',
    }

    console.log(`Subscription frame loaded: ${account} ${mail_key}`);

    // bind 'this' context to handler function to pass it to child component
    this.handleAlerts = this.handleAlerts.bind(this);
  } // END: constructor
  /////////////////////



  /////////////////////////////////////////////////
  // API-call to create new subscription at rule.se
  // PUT https://lensingmedia.azure-api.net/rule/rn/subscribers/:identifier
  apiCreateSubscriber = (form) => {
    this.setState({ fetchInProgress: true });

    // URL to API endpoint: POST /subscribers
    const reqURL = this.state.portal.apis.subscribers;
    console.log("reqUrl: ", reqURL);

    var jsonSubscr = {
      update_on_duplicate: true, // update "resubscribers"
      //"fields_clear": false,         // delete all the other fields!?
      tags: ["Newsletter"], // tags to subscribe to
      // automation: "reset", // toggle automations every time
      require_opt_in: true, // opt-in (triggered only once)
      subscribers: {
        email: form.email,
        language: "de",
        fields: [{ "key": "Preferences."+this.state.mail_key, "value": "active" }] 
      },
    };

    console.log("subscribers_json", jsonSubscr);

    // TODO: show error messages??
    axios
      .post(reqURL, JSON.stringify(jsonSubscr), { headers: { "Content-Type": "application/json" } })
      .then((response) => {
        console.log("RESPONSE:", response);
        this.setState({ message: { type: "success", txt: "Vielen Dank für Ihre Anmeldung!" } });
        this.setState({ fetchInProgress: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ message: { type: "warning", txt: error.message } });
        this.setState({ fetchInProgress: false });
      });
  }; // END: apiCreateSubscriber
  /////////////////////////////

  ////////////////////////////
  // Toggle box state
  //onCheckboxChange = (event) => {
  //  this.setState({ [event.target.name]: event.target.checked });
  //};

  // Toggle state of messages. This method will be sent to the child component <AlertUser>
  handleAlerts = () => {
    this.setState({ message: { type: "success", txt: 0 } });
  };


  ////////////////////////////////////////////////////////////////////////////////
  render() {

    return (
      <>
        { 
          // show messages 
          this.state.message.txt ? (
            <AlertUser type={this.state.message.type} txt={this.state.message.txt} action={this.handleAlerts}></AlertUser>
          ) : (
              // loading screen while ajax running
              this.state.fetchInProgress ? (
                <div className="container-fluid fill">
                  <div className="row h-100">
                    <div className="col-sm-12 my-auto">
                      <BarLoader size={250} color={"#009ee0"} />
                    </div>
                  </div>
                </div>
              ) : (
                  ////////////////////////////////////
                  // content, when no loading screen
                  <>
                    <div className="container-fluid bg-lightblue p-1 m-1">

                      <Formik
                        enableReinitialize // send state changes to formik!
                        //initialValues={{ email: '', acceptedTerms: false }}
                        initialValues={{ email: '' }}
                        validationSchema={validation}
                        onSubmit={(formValues, { setSubmitting }) => {
                          setTimeout(() => {
                            this.apiCreateSubscriber(formValues);
                            console.log("STATE:", this.state);
                          }, 400);

                          setSubmitting(false);
                        }}
                      >

                        <Form>
                          <div className="d-flex flex-wrap align-items-start" >
                            <div className="p-0 pr-1 pb-1 flex-grow-1">
                              <TextInput className="form-control" name="email" type="email" placeholder=" E-Mail-Adresse" width="100%"/>
                            </div>
                            <div className="p-0 pr-4">
                              <button className="btn" type="submit"> Jetzt anmelden </button>
                            </div>
                          </div>
                            <div className="m-0 p-0">
                              <em>Informationen zur Datenverarbeitung im Rahmen des Newsletters finden Sie
                                <a href='#' onClick={()=>popup(this.state.portal.footer.links_bottom[1].url)}> hier.</a>
                              </em>
                            </div>

                          {/** </div> */}
                        </Form>
                      </Formik>
                    </div>
                  </>
                ) // END: if not loading screen

            )
        }
      </>
    );
  }
};

function AccountSetup() {
  return <SignupForm />;
}

function popup(link) {
  //e.preventDefault();
  window.open(link,'consentWindow','width=350,height=430,resizable=yes');
}

export default AccountSetup;